import React from 'react';

import PropTypes from 'prop-types';

import Button from 'components/Button';
import ArrowRight from 'components/SvgComponents/icons/ArrowRight';

const LoginSubmitButton = ({ disabled, loading, children }) => (
  <Button
    startIcon={<ArrowRight height={16} width={16} />}
    size="large"
    type="submit"
    disabled={disabled}
    loading={loading}
  >
    {children}
  </Button>
);

LoginSubmitButton.propTypes = {
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

export default LoginSubmitButton;
